<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <!-- <start-study v-show="!isStart" v-bind:studyInfo="studyInfo" @onStart="onStart"/> -->
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="소리를 듣고 음가에 유의해 해당 단어카드를 선택하세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full mb-4" :key="index" v-for="(item, index) in cardCount">
            <vx-card class="phonics-sm-card flex items-center justify-center" @click="onImageClick(index)">
              <flip-card :prevent-event="false" :ref="'flipCard_' + index">
                <template slot="back" class="phonics-sm-card">
                  <div class="mb-4">
                    <h2 class="text-primary sentence text-center">{{ content.example[index] }}</h2>
                    <br>
                    <h2 class="text-primary sentence text-center"> {{ content.exampleTranslation[index]}} </h2>
                  </div>
                  <!-- <div><h2 class="text-primary sentence text-center">{{ content.exampleTranslation[index]}}</h2></div> -->
                </template>
                <template slot="front">
                  <div slot="no-body">
                    <img :src="content.image[index]" class="image-card-height">
                  </div>
                </template>
              </flip-card>
            </vx-card>
        </div>
      </div>
      <div class="text-center mt-6 hidden">
        <audio ref="audioPlayer" 
          controls 
          v-on:ended="audioFinish" 
          controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>  
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" ></top-button-bar>
  </div>  
</div>
</template>

<script>

const NEXT_WORD_INTERVAL = 1500

import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      isStudying: false,
      reset: false,
      cardCount: 4
    }
  },
  watch: {
    
  },
  computed: {

    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    
    onImageClick (index) {
      
      if (this.content.answer === index + 1) {
        this.audioPlayer.pause()

        this.correct()

        if (this.contentIndex < (this.contentsLen - 1)) {
          
          setTimeout(function () {
            //카드의 플립 상태를 리셋한다.
            for (let i = 0; i < this.cardCount; i++) {
              this.$refs[`flipCard_${  i}`][0].resetFlip()
            }
            // 플립 애니매니션을 대기했다가 다음 문제로 넘어간다.
            setTimeout(function () {
              this.contentIndex++
              this.audioPlayer.src = ''
              this.audioPlayer.currentTime = 0
              this.playAudio(this.audioPlayer, this.content.audio)
            }.bind(this), NEXT_WORD_INTERVAL)

          }.bind(this), NEXT_WORD_INTERVAL)

        } else {
          setTimeout(function () {
            this.onComplete()
          }.bind(this), NEXT_WORD_INTERVAL)
        }
      } else {

        this.inCorrect()

        setTimeout(function () {
          this.$refs[`flipCard_${  index}`][0].resetFlip()
        }.bind(this), NEXT_WORD_INTERVAL)
      }
    },
    onStart () {
      this.playAudio(this.audioPlayer, this.content.audio)
    },
    onReload () {
      this.audioPlayer.pause()
      this.contentIndex = 0
      this.startAlert()
    },
    playAudio (audioPlayer, src) {
      if (this.studyFinished) return
      audioPlayer.src = src
      audioPlayer.play()
    },
    audioFinish () {
      
      setTimeout(function () {
        this.playAudio(this.audioPlayer, this.content.audio)
      }.bind(this), NEXT_WORD_INTERVAL)
      
    },
    acceptAlert () {
      this.onStart()
    },
    startAlert () {
      this.startStudyDlg('소리를 듣고 음가에 유의해 해당 단어카드를 선택하세요.')
    }
  },
  created () {
    
    const contentJson = JSON.parse(this.sourceContent.contentBody)
    
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const arrImage = new Array()
      for (let j = 1; j <= contentJson.example.length; j++) {
        arrImage.push(this.$buildPHImagePath(this.sourceContent.contentCode, i + 1, j).replace('AP1', 'AP2'))
      }
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        example: contentJson.example[i].split('|'),
        exampleTranslation: contentJson.exampleTranslation[i].split('|'),
        answer: parseInt(contentJson.answer[i]),
        image: arrImage,
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1).replace('AP1', 'AP2'),
        fliped: [false, false, false, false]
      } 
      this.contentList.push(content)
    }
    
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
    
  },
  beforeDestroy () { 
    this.audioPlayer.pause()
  }
}

</script>

<style scoped>
.image-card {
  height: 360px
}
.image-box {
    
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-box img {
    max-width: 100%;
    max-height: 100%;
}
</style>
